<template>
    <table v-if="innerSets || innerCustomItems" class="table table-sm table-borderless table-grid table-hover">
        <thead>
        <tr>
            <th width="200">Код</th>
            <th>Наименование</th>
            <th class="fit">Кол-во</th>
            <th width="120">Цена</th>
            <th width="120">Сумма</th>
            <th class="fix"></th>
        </tr>
        </thead>
        <tbody>
            <tr v-for="(item, index) in innerSets" :key="item.code" :class="{'table-danger': item.id === null}">
                <td>{{ item.code }}</td>
                <td v-html="item.section"></td>
                <td>
                    <b-input type="number" class="form-control form-control-sm" min="1" v-model.number="item.quantity"></b-input>
                </td>
                <td>
                    <money class="form-control form-control-sm" v-model="item.price"></money>
                </td>
                <td>{{ item.price * item.quantity | currency }}&nbsp;₽</td>

                <td class="btn-delete">
                    <button type="button" @click="onDelete(index, innerSets)"
                            class="btn btn-sm btn-block btn-outline-danger">
                        Удалить
                    </button>
                </td>
            </tr>
            <tr v-for="(item, index) in innerCustomItems" :key="item.code" class="table-warning">
                <td>{{ item.code }}</td>
                <td v-html="item.section"></td>
                <td>
                    <b-input type="number" class="form-control form-control-sm" v-model.number="item.quantity"></b-input>
                </td>
                <td>
                    <money class="form-control form-control-sm" v-model="item.price"></money>
                </td>
                <td>{{ item.price * item.quantity | currency }}&nbsp;₽</td>

                <td class="btn-delete">
                    <button type="button" @click="onDelete(index, innerCustomItems)"
                            class="btn btn-sm btn-block btn-outline-danger">
                        Удалить
                    </button>
                </td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td><b>Итого:</b></td>
                <td><b>{{ totalPrice | currency }}&nbsp;₽</b></td>
                <td></td>
            </tr>
            </tbody>
    </table>

    <div v-else class="alert alert-danger">
        Нет позиций
    </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: {
    sets: {
      required: true,
      validator: function (value) {
        if (value === null) {
          return true
        }

        if (Array.isArray(value)) {
          if (value.length > 0) {
            return value.every(function (element) {
              return 'id' in element &&
                'code' in element &&
                'name' in element &&
                'quantity' in element &&
                'price' in element
            })
          }
          return true
        }

        return false
      }
    },
    customItems: {
      required: true,
      validator: function (value) {
        if (value === null) {
          return true
        }

        if (Array.isArray(value)) {
          if (value.length > 0) {
            return value.every(function (element) {
              return 'code' in element &&
                'name' in element &&
                'quantity' in element &&
                'price' in element
            })
          }

          return true
        }

        return false
      }
    }
  },
  data () {
    return {
      innerSets: cloneDeep(this.sets),
      innerCustomItems: cloneDeep(this.customItems)
    }
  },

  methods: {
    onDelete (index, data) {
      data.splice(index, 1)
    }
  },

  watch: {
    sets: {
      deep: true,
      handler () {
        this.innerSets = cloneDeep(this.sets)
      }
    },
    customItems: {
      deep: true,
      handler () {
        this.innerCustomItems = cloneDeep(this.customItems)
      }
    },
    innerSets: {
      deep: true,
      handler () {
        if (JSON.stringify(this.sets) !== JSON.stringify(this.innerSets)) {
          this.$emit('update:sets', this.innerSets)
        }
      }
    },
    innerCustomItems: {
      deep: true,
      handler () {
        if (JSON.stringify(this.customItems) !== JSON.stringify(this.innerCustomItems)) {
          this.$emit('update:customItems', this.innerCustomItems)
        }
      }
    }
  },

  computed: {

    totalPrice: function () {
      let setsTotal = 0
      let customTotal = 0

      if (this.innerSets) {
        setsTotal = this.innerSets.reduce((sum, current) => {
          return sum + current.price * current.quantity
        }, 0)
      }

      if (this.innerCustomItems) {
        customTotal = this.innerCustomItems.reduce((sum, current) => {
          return sum + current.price * current.quantity
        }, 0)
      }

      return setsTotal + customTotal
    }
  }
}
</script>

<style>
.btn-delete {
  padding-right: 0;
}
</style>
